
      import { checkLoafSupport } from "/main.js";

      checkLoafSupport();

      // Storage de frames capturados
      const capturedFrames = [];

      // Observer de LoAF
      const observer = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          // Guardar frame completo
          const frameData = {
            startTime: entry.startTime,
            duration: entry.duration,
            renderStart: entry.renderStart,
            styleAndLayoutStart: entry.styleAndLayoutStart,
            firstUIEventTimestamp: entry.firstUIEventTimestamp,
            blockingDuration: entry.blockingDuration,
            scripts: entry.scripts.map((s) => ({
              sourceURL: s.sourceURL || "",
              sourceFunctionName: s.sourceFunctionName || "(anónima)",
              duration: s.duration,
              forcedStyleAndLayoutDuration: s.forcedStyleAndLayoutDuration,
              invoker: s.invoker || "",
            })),
          };

          capturedFrames.push(frameData);
        }
      });

      try {
        observer.observe({
          type: "long-animation-frame",
          buffered: true,
        });
        console.log("✅ LoAF observer iniciado. Helpers disponibles en window.loafHelpers");
      } catch (e) {
        console.error("LoAF no soportado");
      }

      // Helpers globales
      window.loafHelpers = {
        summary() {
          if (capturedFrames.length === 0) {
            console.log("No hay frames capturados aún.");
            return;
          }

          const totalTime = capturedFrames.reduce((sum, f) => sum + f.duration, 0);
          const avgDuration = totalTime / capturedFrames.length;
          const maxDuration = Math.max(...capturedFrames.map((f) => f.duration));

          const severity = {
            critical: capturedFrames.filter((f) => f.duration > 200).length,
            high: capturedFrames.filter((f) => f.duration > 150 && f.duration <= 200).length,
            medium: capturedFrames.filter((f) => f.duration > 100 && f.duration <= 150).length,
            low: capturedFrames.filter((f) => f.duration <= 100).length,
          };

          console.group("📊 LOAF SUMMARY");
          console.log("Total frames:", capturedFrames.length);
          console.log("Total blocking time:", totalTime.toFixed(2) + "ms");
          console.log("Average duration:", avgDuration.toFixed(2) + "ms");
          console.log("Max duration:", maxDuration.toFixed(2) + "ms");
          console.log("");
          console.log("Por severidad:");
          console.log("  🔴 Crítico (>200ms):", severity.critical);
          console.log("  🟠 Alto (150-200ms):", severity.high);
          console.log("  🟡 Medio (100-150ms):", severity.medium);
          console.log("  🟢 Bajo (<100ms):", severity.low);
          console.groupEnd();
        },

        topScripts(n = 10) {
          const allScripts = capturedFrames.flatMap((f) => f.scripts);
          const sorted = allScripts.sort((a, b) => b.duration - a.duration).slice(0, n);

          console.table(
            sorted.map((s) => ({
              URL: new URL(s.sourceURL || location.href).pathname,
              Function: s.sourceFunctionName,
              Duration: s.duration.toFixed(2) + "ms",
              "Forced Layout": s.forcedStyleAndLayoutDuration.toFixed(2) + "ms",
            })),
          );
        },

        filter(options = {}) {
          let filtered = capturedFrames;

          if (options.minDuration) {
            filtered = filtered.filter((f) => f.duration >= options.minDuration);
          }

          if (options.maxDuration) {
            filtered = filtered.filter((f) => f.duration <= options.maxDuration);
          }

          console.log(`Filtrado: ${filtered.length} de ${capturedFrames.length} frames`);
          console.table(
            filtered.map((f) => ({
              Start: f.startTime.toFixed(2) + "ms",
              Duration: f.duration.toFixed(2) + "ms",
              Scripts: f.scripts.length,
            })),
          );

          return filtered;
        },

        findByURL(search) {
          const matches = capturedFrames.filter((f) =>
            f.scripts.some((s) => s.sourceURL.includes(search)),
          );

          console.log(`Encontrados ${matches.length} frames con scripts que incluyen "${search}"`);
          console.table(
            matches.map((f) => {
              const matchingScript = f.scripts.find((s) => s.sourceURL.includes(search));
              return {
                "Frame Start": f.startTime.toFixed(2) + "ms",
                "Frame Duration": f.duration.toFixed(2) + "ms",
                "Script URL": matchingScript.sourceURL,
                "Script Duration": matchingScript.duration.toFixed(2) + "ms",
              };
            }),
          );

          return matches;
        },

        exportJSON() {
          const data = JSON.stringify(capturedFrames, null, 2);
          const blob = new Blob([data], { type: "application/json" });
          const url = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `loaf-data-${Date.now()}.json`;
          a.click();
          URL.revokeObjectURL(url);
          console.log("✅ JSON descargado");
        },

        exportCSV() {
          const rows = [
            [
              "Frame Start",
              "Duration",
              "Scripts",
              "Script URL",
              "Function",
              "Script Duration",
              "Forced Layout",
            ],
          ];

          capturedFrames.forEach((f) => {
            f.scripts.forEach((s) => {
              rows.push([
                f.startTime.toFixed(2),
                f.duration.toFixed(2),
                f.scripts.length,
                s.sourceURL,
                s.sourceFunctionName,
                s.duration.toFixed(2),
                s.forcedStyleAndLayoutDuration.toFixed(2),
              ]);
            });
          });

          const csv = rows.map((row) => row.map((cell) => `"${cell}"`).join(",")).join("\n");
          const blob = new Blob([csv], { type: "text/csv" });
          const url = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `loaf-data-${Date.now()}.csv`;
          a.click();
          URL.revokeObjectURL(url);
          console.log("✅ CSV descargado");
        },

        getRawData() {
          return capturedFrames;
        },

        clear() {
          capturedFrames.length = 0;
          console.log("✅ Datos limpiados");
        },
      };

      // Botones
      document.getElementById("triggerActivityBtn").addEventListener("click", () => {
        // Simular actividad mixta
        const script1 = document.createElement("script");
        script1.src = "/examples/scripts/heavy-computation.js";
        script1.async = true;
        document.head.appendChild(script1);

        setTimeout(() => {
          const script2 = document.createElement("script");
          script2.src = "/examples/third-party-scripts/analytics.js";
          script2.async = true;
          document.head.appendChild(script2);
        }, 100);

        console.log("🎬 Actividad simulada. Ejecuta loafHelpers.summary() para ver resultados.");
      });

      document.getElementById("clearConsoleBtn").addEventListener("click", () => {
        console.clear();
        console.log("✅ Console limpiada. Helpers disponibles en window.loafHelpers");
      });

      document.getElementById("exportJSONBtn").addEventListener("click", () => {
        window.loafHelpers.exportJSON();
      });

      document.getElementById("exportCSVBtn").addEventListener("click", () => {
        window.loafHelpers.exportCSV();
      });

      document.getElementById("copyDataBtn").addEventListener("click", async () => {
        const data = JSON.stringify(capturedFrames, null, 2);
        try {
          await navigator.clipboard.writeText(data);
          alert("✅ Datos copiados al portapapeles");
        } catch (e) {
          console.error("Error copiando:", e);
        }
      });

      // Helper para copiar código
      window.copyToClipboard = async (text) => {
        try {
          await navigator.clipboard.writeText(text);
          console.log("✅ Copiado:", text);
        } catch (e) {
          console.error("Error copiando:", e);
        }
      };

      // Mensaje inicial
      console.log(
        "%c LoAF DevTools Helpers ",
        "background: #1a73e8; color: white; padding: 4px 8px; border-radius: 4px;",
      );
      console.log("Helpers disponibles en window.loafHelpers:");
      console.log("  • summary() - Resumen de frames");
      console.log("  • topScripts(n) - Top N scripts");
      console.log("  • filter(options) - Filtrar frames");
      console.log("  • findByURL(search) - Buscar por URL");
      console.log("  • exportJSON() - Exportar como JSON");
      console.log("  • exportCSV() - Exportar como CSV");
      console.log("  • getRawData() - Obtener datos raw");
      console.log("  • clear() - Limpiar datos");
    